import React from "react";
import { useTranslation } from "react-i18next";

function Tracking() {
  const { t } = useTranslation();

  return (
    <main className="page">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>{t("nav.tracking")}</h1>
          <p>Tra cứu tình trạng vận đơn của bạn</p>
        </div>
      </section>

      <section className="page-container">
        <p>Trang tra cứu vận đơn - Nội dung sẽ được cập nhật</p>
      </section>
    </main>
  );
}

export default Tracking;
